import defaultLocale from '../constants/default-locale';

export default (currencyCode, locale = defaultLocale, options = {}) =>
{
  const LocaleNumberFormat = new Intl.NumberFormat(
    locale,
    { style: 'currency', currency: currencyCode, ...options }
  );

  return price => LocaleNumberFormat.format(price);
};
